import t from "./v-text-input.vue2.js";
import "./v-text-input.vue.js";
const p = t;
export {
  p as VTextInput
};
